<div class="header">
    <h2>{{ 'quiz-questions.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="quiz-questions-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'quiz-questions.error.unavailable' | translate" />
} @else if (quizQuestion(); as quizQuestion) {
    <div class="body">
        <div class="entity-header">
            <div class="identity">
                <h1>{{ quizQuestion.questionText }}</h1>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'quiz-questions.answers.title' | translate }}</h2>
            @if (quizQuestion.answers.length > 0) {
                <div class="items">
                    @for (answer of quizQuestion.answers; track answer.value; let i = $index) {
                        <div class="item">
                            <p-badge [value]="'' + (i + 1)" [severity]="answer.correct ? 'success' : 'secondary'" />
                            <span class="name">{{ answer.value }}</span>
                            @if (answer.correct) {
                                <i class="pi pi-check correct"></i>
                            }
                        </div>
                    }
                </div>
            } @else {
                <p class="empty">{{ 'quiz-questions.answers.empty' | translate }}</p>
            }
        </div>
    </div>

    <div class="footer">
        <app-delete-button [quizQuestionId]="quizQuestion.id" [saving]="saving()" testId="quiz-questions-view-delete" />
        <p-button [label]="'quiz-questions.detail.edit' | translate" icon="pi pi-pencil" data-test="quiz-questions-view-edit" (onClick)="onEdit()" />
    </div>
}
